import React from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { useAuth } from '@/hooks/useAuth';
import Login from './Login';
import LoadingScreen from './LoadingScreen';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, inProgress, isLoadingUser } = useAuth();

  // Show loading screen during MSAL operations or when fetching user info
  if (inProgress !== InteractionStatus.None || isLoadingUser) {
    return <LoadingScreen />;
  }

  // Show login if not authenticated
  if (!isAuthenticated) {
    return <Login />;
  }

  // Show the app
  return <>{children}</>;
};

export default AuthGuard;